(function () {
    'use strict';

    angular
       .module('blocks.auth')
       .factory('authInterceptor', authInterceptor)
       .config(config);

    config.$inject = ['$httpProvider'];

    /* @ngInject */
    function config($httpProvider) {
        $httpProvider.interceptors.push('authInterceptor');
    }

    authInterceptor.$inject = ['$q', '$location', '$injector', '$window', 'config', 'notifier'];
    /* @ngInject */
    function authInterceptor($q, $location, $injector, $window, config, notifier) {
        var inFlightAuthRequest = null;

        var service = {
            request: request,
            responseError: responseError
        };

        return service;
        ///////

        
        function request(config) {
            config.headers = config.headers || {};
            var userData = JSON.parse($window.localStorage.getItem('7PointUserData'));
            if (userData && userData.bearerToken) {
                if (config.url) {
                    if (config.url.indexOf('html') === -1) {
                        
                        config.headers.Authorization = 'Bearer ' + userData.bearerToken;
                    }
                }
                
            }
            if (config.url) {
                if (config.url.indexOf('.html') === -1) {
                    if (config.headers) {
                        var bt = document.getElementById("mainBodyTag");
                        config.headers["X-CSFR-Token"] = bt.getAttribute("sp-request-verification-token");
                    }
                }
            }

            return config || $q.when(config)
        }

        
        function responseError(rejection) {
            if (rejection.status === 401) {
                $window.localStorage.removeItem('7PointUserData');
                notifier.notify(config.events.authenticationChange);
                $injector.get('$state').go('login', { returnUrl: $location.path() });
            }
            return $q.reject(rejection);
        }
        

        function responseErrorRefresh(response) {
            if (response.status === 401) {
                $injector.get('$state').go('logout', { reason: "Your session was terminated, please login in again" });
                if (response.data === "SessionRevoked") {
                    $injector.get('$state').go('logout', { reason: "Your session was terminated, please login in again" });
                }
                else {
                    
                    var deferred = $q.defer();
                    if (!inFlightAuthRequest) {
                        var userData = JSON.parse($window.localStorage.getItem('7PointUserData'));
                        if (userData && userData.refreshToken) {
                            var data = { "grant_type": "refresh_token", "refresh_token": userData.refreshToken }
                            var refreshTokenConfig = {
                                headers: { "Content-Type": "application/x-www-form-urlencoded" },
                                transformRequest: function (obj) {
                                    var str = [];
                                    for (var p in obj) {
                                        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                                    }
                                    return str.join("&");
                                }
                            };
                            inFlightAuthRequest = $injector.get("$http").post('Token', data, refreshTokenConfig);
                        }
                        else {
                            $window.localStorage.removeItem('7PointUserData');
                            notifier.notify(config.events.authenticationChange);
                            $injector.get('$state').go('login', { returnUrl: $location.path() });
                            return;
                        }
                    }

                    inFlightAuthRequest.then(function (r) {
                        
                        inFlightAuthRequest = null;
                        userData = {};
                        var d = r.data;
                        userData.isAuthenticated = true;
                        userData.userName = d.UserName;
                        userData.userType = d.UserType;
                        userData.userId = d.UserId;
                        userData.tenantId = d.TenantId;
                        userData.bearerToken = d.access_token;
                        userData.refreshToken = d.refresh_token;
                        userData.hasOps = d.HasOps;
                        userData.numberOfPaymentTemplates = d.NumberOfPaymentTemplates;
                        userData.numberOfDisplayTemplates = d.NumberOfDisplayTemplates;
                        userData.departmentIds = d.DepartmentIds;
                        userData.billingDepartmentIds = d.BillingDepartmentIds;
                        userData.activeUntilUtc = d.ActiveUntilUtc;
                        userData.apiTypeId = d.ApiTypeId;
                        userData.expirationDate = new Date(d['.expires']);
                        userData.filterTypeId = d.FilterTypeId;
                        userData.hasDataApi = d.HasDataApi;
                        $window.localStorage.setItem('7PointUserData', JSON.stringify(userData));

                        $injector.get('$http').get('api/Users/FilterData/' + d.FilterTypeId).then(function (response) {
                            userData.filterData = response.data;
                            $window.localStorage.setItem('7PointUserData', JSON.stringify(userData));
                        });
                        


                        $injector.get('$http')(response.config).then(function (resp) {
                            deferred.resolve(resp);
                        }, function (resp) {
                            deferred.reject();
                        });
                    }, function (response) {
                        inFlightAuthRequest = null;
                        $window.localStorage.removeItem('7PointUserData');
                        notifier.notify(config.events.authenticationChange);
                        deferred.reject();
                        $injector.get('$state').go('login', { returnUrl: $location.path() });

                        return;
                    });

                    return deferred.promise;
                    
                }
            }
            return response || $q.when(response)
        }
    }
})();
